import { Building2 } from 'lucide-react';

import RestaurantEmptyState from '../../shared/RestaurantEmptyState';

const PrinterBranchEmpty = () => {
  return (
    <RestaurantEmptyState
      icon={Building2}
      title="No hay sucursales disponibles"
      description="Registre una sucursal antes de configurar las impresoras que recibirán comandas, etiquetas y recibos."
      hint="Configure una sucursal antes de continuar"
    />
  );
};

export default PrinterBranchEmpty;
